import { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { GomakePrimaryButton } from "@/components";
import { startOidcLogin } from "@/services/api-service/auth/oidc-api";
import { InviteSplash } from "./invite-splash";

/**
 * HP invitees never see the 3-provider picker. This is a blank handoff screen while we send
 * them to Login with HP. Prefer a server 302 from the invite page; this is the client fallback.
 */
const HpInviteHandoff = () => {
  const router = useRouter();
  const [errorMsg, setErrorMsg] = useState("");
  const startedRef = useRef(false);

  const inviteToken =
    typeof router.query.token === "string" ? router.query.token : undefined;

  const goToHp = () => {
    if (!inviteToken) {
      setErrorMsg("This invitation link is invalid.");
      return;
    }
    setErrorMsg("");
    startOidcLogin({
      provider: "hp",
      inviteToken,
      originHost: window.location.host,
    })
      .then((authorizeUrl) => {
        if (authorizeUrl) {
          // replace() so Back does not return to this invite page.
          window.location.replace(authorizeUrl);
          return;
        }
        startedRef.current = false;
        setErrorMsg("Could not open HP login. Please try again.");
      })
      .catch((error: any) => {
        startedRef.current = false;
        setErrorMsg(error?.message || "Could not open HP login. Please try again.");
      });
  };

  useEffect(() => {
    if (!router.isReady || startedRef.current) return;
    startedRef.current = true;
    goToHp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.isReady, inviteToken]);

  if (!errorMsg) {
    return <InviteSplash />;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
      }}
    >
      <div style={{ textAlign: "center", padding: 24, maxWidth: 360 }}>
        <p style={{ color: "#d32f2f", fontSize: 14, marginBottom: 16 }}>
          {errorMsg}
        </p>
        <GomakePrimaryButton onClick={goToHp}>Try again</GomakePrimaryButton>
      </div>
    </div>
  );
};

export { HpInviteHandoff };
